import { useCallback, useEffect, useState } from 'react';
import { List, Typography } from 'antd';
import styled from 'styled-components';

// services
import * as DashboardService from '../../../../services/bb-api/dashboards';
import { ImageReloader } from '../image-reloader';

export function NewPosts(props: any): JSX.Element {
	const setShowError = props.setShowError;
	const [postData, setPostData] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	const callbackNewPostsQuery: () => Promise<void> = useCallback(async () => {
		try {
			const posts = await DashboardService.queryNewPosts();
			setPostData(posts);
		} catch (error) {
			setShowError(true);
		}

		setLoading(false);
	}, [setShowError]);

	// initialQuery is run on first render of page
	useEffect(() => {
		callbackNewPostsQuery();
	}, [callbackNewPostsQuery]);

	// useEffect to run initialQuery method once every minute and will also unmount
	useEffect(() => {
		const interval: NodeJS.Timeout = setInterval(async () => {
			await callbackNewPostsQuery();
		}, 60_000);

		return () => clearInterval(interval);
	}, [callbackNewPostsQuery]);

	function handleRenderListItem(item: any): JSX.Element {
		const imageSource: string = String(process.env.REACT_APP_POST_IMAGE_PATH) + item.filename;

		return (
			<List.Item>
				<List.Item.Meta
					title={item.title}
					avatar={<ImageReloader className="activities-img-reload" src={imageSource} />}
					description={<Typography.Text ellipsis>{item.body}</Typography.Text>}
				/>
			</List.Item>
		);
	}

	return (
		<Container className="panel-container new-posts-panel">
			<h2>Nyeste Bobler</h2>
			<div className="panel-data">
				<List dataSource={postData} renderItem={handleRenderListItem} loading={loading} />
			</div>
		</Container>
	);
}

const Container = styled.div`
	.panel-data {
		display: block;

		li {
			padding: 1em;
		}
	}

	.ant-list-item-meta-title {
		color: #9ca3af;
		font-size: 1.5em;
		margin-bottom: 0px;
	}

	.ant-list-item-meta-description > span {
		font-size: 1.2em;
		color: #ffffff;
	}
`;
